export default __webpack_public_path__ + "static/media/2.214c1a1e.png";